import {Action, createAction} from '@reduxjs/toolkit';

type BatchAction = Action | undefined | null | false;

export const batchActions = createAction<BatchAction[]>('actions/batch');
